module.exports = __webpack_public_path__ + "static/media/drag-points.4c929de7.svg";